export default __webpack_public_path__ + "static/media/a.ed137b3a.mp4";